import React from 'react'
import { FiChevronDown } from "react-icons/fi";

const BundlePackage = () => {
    return (
        <section className="py-5 position-relative"
            style={{
                overflow: 'hidden'
            }}
        >
            <div
                className="px-4 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1
                }}
            >
                {/* pill box */}
                <div className="adon-box">
                    <div className="adon-content">
                        <h4 className="adon-title">Bundled Packages</h4>
                        <p className="adon-sub">
                            You can buy adon as per your business requirements, kindly note WhatsApp Managed Services is offered as paid adon and not included in any of the base plans
                        </p>
                    </div>
                    <FiChevronDown className="adon-icon" />
                </div>
            </div>

            {/* styles */}
            <style>{`
          .adon-box {
          margin-top: -3rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            background: linear-gradient(90deg, #f3f7ffff 0%, #fff4e6ff 100%);
            border-radius:18px;
            padding:28px 18px;
            border: 1px solid rgba(0,0,0,0.06);
            box-shadow: 0 4px 12px rgba(0,0,0,0.06);
          }
          .adon-title {
            margin: 0;
            font-family: Inter;
            font-size:20px;
            font-weight:600;
            color: #242121ff;
            letter-spacing:.1px;
          }
          .adon-sub {
            margin: 4px 0 0;
            font-size: 18px;
            font-family: Lato;
            font-weight:400;
            color: #4a4a4a;
            line-height: 1.3;
            max-width: 90%;
          }
          .adon-icon {
            font-size: 18px;
            color: #444;
            flex-shrink: 0;
          }
        `}</style>
        </section>
    );
};
export default BundlePackage